export default __webpack_public_path__ + "static/media/inline-colorful1.cef8c92e.png";